import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import { motion } from "framer-motion";

const generateTestimonial = () => {
  const names = ["Anjali", "Priya", "Riya", "Kavya", "Megha", "Simran"];
  const messages = [
    "Absolutely love staying here! So safe and peaceful.",
    "The food is amazing and rooms are super clean.",
    "Perfect location near coaching centers.",
    "Great atmosphere to study and relax.",
    "The best hostel I've lived in!", 
    "Highly recommended for any student in Kota!",
  ];
  const ratings = [4, 5];

  return Array.from({ length: 6 }, (_, i) => ({
    id: i,
    name: names[i % names.length],
    message: messages[i % messages.length],
    rating: ratings[Math.floor(Math.random() * ratings.length)],
  }));
};

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setTestimonials(generateTestimonial());
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % 6);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const testimonial = testimonials[currentIndex];

  return (
    <section
      id="testimonials"
      className="py-16 bg-gradient-to-r from-rose-100 to-teal-100 animate__animated animate__fadeIn"
    >
      <div className="text-center mb-10">
        <h2 className="text-4xl font-bold text-pink-600 mb-2 animate-bounce">
          What Our Residents Say
        </h2>
        <p className="text-lg text-gray-700">
          Genuine reviews from girls living at Navya Residency.
        </p>
      </div>

      {testimonial && (
        <motion.div
          key={testimonial.id}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto p-6 bg-white rounded-2xl shadow-xl text-center"
        >
          <p className="text-xl italic text-gray-700 mb-4">
            "{testimonial.message}"
          </p>
          <div className="text-yellow-400 mb-2 flex justify-center">
            {Array.from({ length: testimonial.rating }).map((_, i) => (
              <FaStar key={i} className="mx-1" />
            ))}
          </div>
          <p className="text-lg font-semibold text-purple-600">
            - {testimonial.name}
          </p>
        </motion.div>
      )}
    </section>
  );
};

export default Testimonials;
